@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.alert-detail-page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.go-back-to-batches-button {
  cursor: pointer;
  height: 50px;
  width: 50px;
  margin-left: -17px;

  > svg {
    fill: @alert-details-page--back-button--fill-color;
    width: 100%;
    height: 100%;
    transform: scale(0.4);
  }

  &:hover {
    > svg {
      fill: @alert-details-page--back-button--hover--fill-color;
    }
    text-decoration: none;
  }
}

.grid {
  flex-grow: 1;
  width: 100%;
  height: calc(100% ~'-' 42px);
  overflow: auto;
}

.grid-content {
  flex-grow: 1;
  display: flex;
  height: calc(100% ~'-' 102px);
  overflow-y: hidden;
  background-color: @alert-details-page--grid-content--background-color;
}

.paging-footer {
  min-height: 42px;
  border-top: 1px solid @alert-details-page--paging-footer--border-color;
}

.actions-section {
  display: flex;
  background-color: @alert-details-page--actions-section--background-color;
  padding-bottom: 15px;
  padding-left: 5px;
}

.alert-supplemental {
  padding: 15px 0;
  font-size: 15px;
  color: @alert-details-page--alert-supplemental--text-color;
}

.edit-grid-wrap {
  display: flex;
  justify-content: space-between;
}

.side-bar {
  width: 446px;
  border-left: 1px solid @alert-details-page--side-bar--border-color;
}

.grid-and-footer {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: calc(100% ~'-' 446px);

  &.no-sidebar {
    max-width: 100%;
  }
}

.edit-columns-and-drawer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 10px;
}
